import { render, staticRenderFns } from "./amapDemo.vue?vue&type=template&id=4cc1ac8f"
import script from "./amapDemo.vue?vue&type=script&lang=js"
export * from "./amapDemo.vue?vue&type=script&lang=js"
import style0 from "./amapDemo.vue?vue&type=style&index=0&id=4cc1ac8f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports